document.addEventListener('DOMContentLoaded', function(){
  
  $('.slick1 img').css({
          'max-height':$('.slick1').width()*0.85
        });
  $('.featured-container.featured-container-product-template img').css({
          'max-height':$('.featured-container.featured-container-product-template').width()*0.85
        });
  $('.simple-collection figure .image-cell').height($('.simple-collection figure .image-cell').width());
  $('.simple-collection figure .image-cell img').css({
    'max-height': $('.simple-collection figure .image-cell').width()
  });
  if($(".slick1").children('li').length >= 1) {
      $('.slick1, .product-images.thumbnails-placement-below .thumbnails li').height($('.slick1').width()*0.85);
      $(".featured-container.featured-container-product-template").css({
          'display':'none'
      });
      $('.slick1').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          focusOnSelect: true,
          centerMode: true,
          centerPadding: 0,
          initialSlide: 0,
          dots: true
      });
    
}

var navbar =  $('#AddCartButton');  // navigation block
var bp1 = navbar.position().top;
var w = '230px';
$(document).ready(function(){
//   $( ".slick-slide" ).each(function( index ) { 
//   var mt = ($('.slick-slider').height()-$(this).height())/2;
//   if (mt>0) $( this ).css('margin-top',
//     mt+'px');
// });
    var nsc = $(document).scrollTop() + $('header.util').height();
    if (nsc >= bp1) {     
      
      var w2 = $(document).width();
      if (w2<430) {
        w2 = w2-200;
      	navbar.css({
          'position':'fixed',
          'bottom': '20px',
          'right': '50%',
          'width': w2+'px',
          'z-index': 1,
          'transform': 'translate(50%, 0%)'
        });
      } else {
        navbar.css({
          'position':'fixed',
          'bottom': '20px',
          'right': '100px',
          'width': w,
          'z-index': 1
        });
      }
      
    } else {
      navbar.css({
        'position':'static',
        'width': 'unset',
        'transform': 'none'
      });
    }
})
$(window).scroll(function(){
    var nsc = $(document).scrollTop() + $('header.util').height() + $('div#shopify-section-promos').height();
    if (nsc >= bp1) {
        var w2 = $(document).width();
      if (w2<430) {
        w2 = w2-200;
      	navbar.css({
          'position':'fixed',
          'bottom': '20px',
          'right': '50%',
          'width': w2+'px',
          'z-index': 1,
          'transform': 'translate(50%, 0%)'
        });
      } else {
        navbar.css({
          'position':'fixed',
          'bottom': '20px',
          'right': '100px',
          'width': w,
          'z-index': 1
        });
      }
    } else {
        navbar.css({
          'position':'static',
          'width': 'unset',
          'transform': 'none'
        });
    }
});
});

